<template>
    <div class="location-input search-component dropdown" :class="{ 'flex-grow-1': ! inline, 'inline': inline }">
        <label for="region" class="w-100" :class="{ focus: isFocus || dropdownVisible }" @click="toggleDropdown">
            <div class="group">
                <span class="label-text" v-if="! inline">
                    {{ 'search.locationInput.label' | trans }}
                </span>

                <!-- Icon -->
                <i class="icon far fa-map-marker-alt" v-if="inline"></i>

                <!-- Region query -->
                <input
                type="text"
                class="blank-control"
                id="region"
                :value="value"
                @input="updateValue"
                :placeholder="'search.locationInput.placeholder' | trans"
                @focus="handleFocus"
                @blur="handleBlur"
                autocomplete="off"
                ref="regionQueryInput" />
            </div>
        </label>

        <div class="dropdown-menu show w-100 py-0 overflow-hidden" v-show="dropdownVisible">
            <div v-for="(group, type) in groupedItems">
                <!-- Header -->
                <span class="type-header">
                    {{ 'search.regions.types.' + type | trans }}
                </span>

                <!-- Region item -->
                <a class="dropdown-item region-item"
                href="#"
                v-if="type !== 'accommodation'"
                v-for="item in group"
                @click.prevent="selectLocation(item)">
                    <i :class="typeIcon(type, item.country_code)" v-if="typeIcon(type)"></i>

                    <span class="info">
                        <span class="name">
                            {{ item.name }}
                        </span>

                        <small class="shortname">
                            {{ item.shortname_cropped }}
                        </small>
                    </span>

                    <!-- <small class="property-count" v-if="item.property_count > 0">
                        {{ item.property_count }}
                    </small> -->
                </a>

                <!-- Property item -->
                <a class="dropdown-item property-item"
                href="#"
                v-if="type === 'accommodation'"
                v-for="item in group"
                @click.prevent="selectLocation(item)">
                    <i :class="typeIcon(type, item.country_code)" v-if="typeIcon(type)"></i>

                    <span class="info">
                        <span class="name">
                            {{ item.name }}
                        </span>

                        <small class="shortname">
                            <span v-if="item.hotel && item.hotel.stars">
                                {{ item.hotel.stars }}
                                {{ 'search.locationInput.hotelStars' | trans }}
                                &bull;
                            </span>

                            {{ item.shortname }}
                        </small>
                    </span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['value', 'location', 'inline', 'type'],
        data() {
            return {
                tmpValue: '',
                content: this.value,
                isLoading: false,
                items: null,
                cancelSource: null,
                isFocus: false,
                showDropdown: false,
            }
        },
        mounted() {
            console.log('type', this.type)
        },
        computed: {
            groupedItems() {
                // Fallback if no result is available
                if (! this.items) {
                    return {}
                }

                let groupedItems = this.$lodash.groupBy(this.items, 'type')
                
                return groupedItems
            },
            dropdownVisible() {
                return this.items && this.items.length > 0 && this.showDropdown && this.value !== null && String(this.value).length > 0
            },
        },
        methods: {
            takeLocationName() {
                if (this.location && this.location.name && ! this.value) {
                    this.$emit('input', this.location.name)
                }
            },
            handleFocus() {
                this.isFocus = true
                this.tmpValue = this.value
                this.resetInput()
            },
            handleBlur() {
                this.isFocus = false

                if (String(this.value).trim().length === 0) {
                    this.$emit('input', this.tmpValue)
                }
            },
            updateValue(event) {
                this.$emit('input', event.target.value)

                if ((! this.location || (this.location && event.target.value !== this.location.name)) && event.target.value.length > 0) {
                    this.search(event.target.value)
                }
            },
            resetInput() {
                this.$emit('input', '')
            },
            selectLocation(item) {
                this.$emit('input', item.name)
                this.$emit('changeLocation', item)
                this.items = null
                this.showDropdown = false
            },
            search(value = '') {
                var self = this;

                const searchValue = value || this.value;

                if (searchValue.length === 0) {
                    return;
                }

                // Cancel previous search
                if (this.cancelSource !== null) {
                    this.cancelSource.cancel()
                }

                // Create cancel token
                const CancelToken = axios.CancelToken
                this.cancelSource = CancelToken.source()

                this.isLoading = true

                axios.get(route('api.frontend.autocomplete'), {
                    params: {
                        query: searchValue,
                    },
                    cancelToken: this.cancelSource.token,
                }).then(function (response) {
                    self.items = response.data.data
                    self.showDropdown = true
                    self.isLoading = false
                }).catch(function (error) {
                    self.isLoading = false
                });
            },
            typeIcon(type, countryCode) {
                let icons = {
                    'continent': 'wa-icon-notification-world',
                    'country': 'flag-icon flag-icon-squared flag-icon-' + countryCode,
                    'province_state': 'wa-icon-map',
                    'high_level_region': 'wa-icon-map',
                    'multi_city_vicinity': 'wa-icon-map',
                    'city': 'wa-icon-city',
                    'neighborhood': 'wa-icon-flag-map-pin',
                    'airport': 'wa-icon-airplane',
                    'point_of_interest': 'wa-icon-place-marker',
                    'train_station': 'wa-icon-train',
                    'metro_station': 'wa-icon-tram',
                    'accommodation': 'wa-icon-home',
                }

                return icons[type] ? icons[type] : null
            },
            toggleDropdown() {
                this.$root.$refs.search.hideDropdowns('locationInput')

                this.showDropdown = ! this.showDropdown
            },
            hideDropdown() {
                this.showDropdown = false
            },
            focus() {
                if (this.$refs.regionQueryInput) {
                    this.$refs.regionQueryInput.focus()
                }
            },
        },
        watch: {
            value() {
                // this.search()
            },
            location: {
                handler(val) {
                    this.takeLocationName()
                },
                deep: true,
            },
            dropdownVisible() {
                $('div.location-input i.fa-chevron-down').animateRotate(this.dropdownVisible ? -180 : 0, 150, 'swing');
            },
        }
    }
</script>
